
// Rounds a number to a specified number of decimal places.
// This is needed because built in JS rounding is not always accurate with decimal places.
// See https://stackoverflow.com/questions/11832914/how-to-round-to-at-most-2-decimal-places-if-necessary for more info
export const round = (value, places) => {
    return +(Math.round(value + "e+" + places)  + "e-" + places);
};